export const iconFontAwesomeMediaplaybackArrowsRotate = (
	<i className="fa-solid fa-arrows-rotate"></i>
);
